import React from 'react'
import { ItemList, SidebarButton } from './styles'
import { IconName } from '~/assets/icons'
import { IconComponent } from '~/assets/icons/component'
import { TimelineTooltip } from '~/components/shared'

export interface IMenuSidebarItem {
  id: string
  buttonLabel: string
  isActive: boolean
  to: string
  handleSelect?: () => void
  linkIcon?: IconName
  isCollapsed: boolean
}

interface WithTooltipProps {
  isTooltipActive: boolean
  description: string
  children: JSX.Element
}

const WithTooltip = ({ isTooltipActive, description, children }: WithTooltipProps): JSX.Element => {
  if (isTooltipActive) {
    return (
      <TimelineTooltip description={description} position="right">
        {children}
      </TimelineTooltip>
    )
  }

  return children
}

const SelectedItemArrow = ({ id }: { id: string }): JSX.Element => (
  <div aria-hidden="true" className="arrowIcon" data-testid={`arrow-${id}`}>
    <IconComponent name="chevronRight"></IconComponent>
  </div>
)

const ItemIcon = ({ id, iconName }: { id: string; iconName: IconName }): JSX.Element => (
  <div aria-hidden="true" data-testid={`icon-${id}`} className="linkIcon">
    <IconComponent name={iconName} iconsize={20} />
  </div>
)

const MenuSidebarItem = ({
  handleSelect,
  isActive,
  id,
  buttonLabel,
  to,
  linkIcon,
  isCollapsed
}: IMenuSidebarItem): JSX.Element => {
  return (
    <ItemList>
      <WithTooltip isTooltipActive={isCollapsed} description={buttonLabel}>
        <SidebarButton
          onClick={handleSelect}
          data-testid={id}
          to={to}
          className={isActive ? 'active' : 'inactive'}
          $isCollapsed={isCollapsed}
        >
          {linkIcon && <ItemIcon id={id} iconName={linkIcon} />}
          {!isCollapsed && <p>{buttonLabel}</p>}
          {isActive && !isCollapsed && <SelectedItemArrow id={id} />}
        </SidebarButton>
      </WithTooltip>
    </ItemList>
  )
}

export { MenuSidebarItem }
